import { render, staticRenderFns } from "./AtualizarRotas.vue?vue&type=template&id=76c9684a&"
import script from "./AtualizarRotas.vue?vue&type=script&lang=js&"
export * from "./AtualizarRotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports